// ═══════════════════════════════════════
// VOICE-MENU — Liste des voix dans la barre d'actions
// Reprend le masquage des voix de l'éditeur (bouton œil) pour
// qu'il reste accessible quand l'éditeur est caché.
// Le bouton n'apparaît que si la partition compte au moins 2 voix.
// ═══════════════════════════════════════

import { getVoiceVisibilityItems, toggleVoiceVisibility, ICON_EYE, ICON_EYE_OFF } from './header-form.js';
import { t } from './i18n.js';

function _render() {
    const wrap = document.getElementById('voices-menu-wrap');
    const menu = document.getElementById('voices-menu');
    if (!wrap || !menu) return;

    const items = getVoiceVisibilityItems();
    wrap.hidden = items.length < 2;

    menu.innerHTML = '';
    items.forEach(item => {
        const btn = document.createElement('button');
        btn.type      = 'button';
        btn.className = 'ctrl-menu-item ctrl-menu-item--voice';
        btn.setAttribute('role', 'menuitemcheckbox');
        btn.setAttribute('aria-checked', String(!item.hidden));
        btn.setAttribute('data-keep-open', '');
        btn.classList.toggle('is-hidden', item.hidden);
        btn.classList.toggle('is-locked', item.locked);
        if (item.locked) btn.setAttribute('aria-disabled', 'true');
        btn.title = item.locked
            ? t('hf.voice_hide_last')
            : (item.hidden ? t('hf.voice_show') : t('hf.voice_hide'));

        btn.innerHTML = `<span class="ctrl-menu-item-label"></span>`
                      + `<span class="ctrl-menu-item-icon">${item.hidden ? ICON_EYE_OFF : ICON_EYE}</span>`;
        btn.querySelector('.ctrl-menu-item-label').textContent = item.label;

        btn.addEventListener('click', () => {
            if (item.locked) return;
            toggleVoiceVisibility(item.idx);
        });
        menu.appendChild(btn);
    });
}

export function initVoiceMenu() {
    // Émis par header-form.js à chaque changement de voix ou de masquage
    document.addEventListener('scorou:voices-changed', _render);
    // Rafraîchit les libellés (instrument modifié…) à chaque ouverture
    document.getElementById('voices-menu-wrap')?.addEventListener('ctrl-menu:open', _render);
    _render();
}
